import { render } from "./MusicTree.vue?vue&type=template&id=ce3fa0ac"
import script from "./MusicTree.vue?vue&type=script&lang=ts"
export * from "./MusicTree.vue?vue&type=script&lang=ts"
script.render = render

export default script